import GATSBY_COMPILED_MDX from "/opt/build/repo/src/javascript/05-events/32-accessibility-gotchas-and-keyboard-codes/32-accessibility-gotchas-and-keyboard-codes.mdx";
import React from 'react';
import {graphql} from 'gatsby';
import {IoLogoGithub} from 'react-icons/io';
import {Helmet} from 'react-helmet';
import H from '../components/mdxComponents/Headings';
import ContentNav from '../components/ContentNav';
import PostHeaderStyles from '../components/styles/PostHeaderStyles';
import EditDialogStyles from '../components/styles/EditDialogStyles';
import JavaScriptNotesStyles from '../components/styles/JavaScriptNotesStyles';
import {PostMetaTags} from '../components/MetaTags';
import TableOfContents from '../components/TableOfContents';
import {getIds} from '../utils/getIds';
import {useActiveId} from '../hooks/useActiveId';
import {BeginnerJavaScript} from '../components/beginnerJavaScript';
export const pageQuery = graphql`
  query ($slug: String!) {
    site {
      siteMetadata {
        title
        author
      }
    }
    mdx(fields: { slug: { eq: $slug } }) {
      id
      parent {
        ... on File {
          absolutePath
        }
      }
      frontmatter {
        title
        slug
        category
      }
      body
      tableOfContents(maxDepth: 10)
    }
  }
`;
function JavaScriptNotesTemplate({data: {mdx: post}, scope, pageContext, children}) {
  const activeId = useActiveId(getIds(post.tableOfContents.items));
  if (!post) {
    return React.createElement("p", null, "No Post Found? This should be a 404");
  }
  const editURL = `https://github.com/wesbos/wesbos/tree/master/src/${post.parent.absolutePath.split('/src/')[1]}`;
  return React.createElement(JavaScriptNotesStyles, null, React.createElement(TableOfContents, {
    activeId: activeId,
    currentPage: pageContext.slug
  }), React.createElement("article", null, React.createElement(PostHeaderStyles, null, React.createElement(PostMetaTags, {
    post: post
  }), React.createElement(H, null, post.frontmatter.title), React.createElement(BeginnerJavaScript), React.createElement("div", {
    className: "postMeta"
  }, React.createElement("span", null, post.frontmatter.category.join(', ')), React.createElement("a", {
    rel: "noopener noreferrer",
    target: "_blank",
    href: editURL
  }, "Edit Post ", React.createElement(IoLogoGithub)))), children, React.createElement(EditDialogStyles, null, React.createElement("p", null, "Find an issue with this post? Think you could clarify, update or add something?"), React.createElement("p", null, "All my posts are available to edit on Github. Any fix, little or small, is appreciated!"), React.createElement("p", null, React.createElement("a", {
    rel: "noopener noreferrer",
    target: "_blank",
    href: editURL
  }, React.createElement(IoLogoGithub), " Edit on Github"))), React.createElement(ContentNav, {
    pathPrefix: pageContext.pathPrefix,
    prev: pageContext.prev,
    next: pageContext.next
  }), React.createElement(Helmet, null, React.createElement("title", null, post.frontmatter.title, " - Beginner JavaScript - Wes Bos"))));
}
JavaScriptNotesTemplate
export default function GatsbyMDXWrapper(props) {
  return React.createElement(JavaScriptNotesTemplate, props, React.createElement(GATSBY_COMPILED_MDX, props));
}
